import React, { useEffect, useRef, useState, FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import { googleClickSearchEvent } from '../../../../../utils/analytics';
import Icon from '../../../../@shared/icon';
import { TInputBox } from '../../../types/index.types';

const InputBox: FC<TInputBox> = (props) => {
  const { searchTerm, setSearchTerm, t, searchResultCount } = props;
  const [isClickedonSearch, setIsClickedOnSearch] = useState(false);
  const timer = useRef<any>(null);

  const handleKeyUp = (event) => {
    setSearchTerm(event?.currentTarget?.value);
    clearTimeout(timer?.current);

    if (event.key === 'Enter') {
      setIsClickedOnSearch(true);
    } else {
      timer.current = setTimeout(() => {
        if (searchTerm) {
          setIsClickedOnSearch(true);
        }
      }, 2000);
    }
  };

  useEffect((): void => {
    if (!isClickedonSearch) {
      return;
    }
    setIsClickedOnSearch(false);
    googleClickSearchEvent(searchTerm, searchResultCount && searchResultCount());
  }, [isClickedonSearch, searchResultCount, searchTerm]);

  return (
    <div className="model-details-specification-table-header__search-input">
      <div className={`model-details-specification-table-header__search-input__container ${searchTerm && 'typed-input'}`}>
        <Icon iconName="action-search" size={iconSize.dsk} extraClassName="table-search-icon" />
        <div className="model-details-specification-table-header__search-input__inner-container">
          {searchTerm && (
            <label slot="label" className="model-details-specification-table-header__search-input__label">
              {t('cnhi-inputLabel')}
            </label>
          )}
          <input
            name="Search"
            placeholder={t('cnhi-inputLabel')}
            type="text"
            className="model-details-specification-table-header__search-input__input"
            onKeyUp={handleKeyUp}
          ></input>
        </div>
      </div>
    </div>
  );
};
export default InputBox;
